import { cn } from './ui/utils';

const GLOW_VARIANTS = {
  purple: {
    blob1: 'bg-purple-400/20',
    blob2: 'bg-indigo-300/25',
  },
  cyan: {
    blob1: 'bg-cyan-400/20',
    blob2: 'bg-sky-300/25',
  },
  blue: {
    blob1: 'bg-blue-400/20',
    blob2: 'bg-indigo-300/25',
  },
  indigo: {
    blob1: 'bg-indigo-400/20',
    blob2: 'bg-blue-300/25',
  },
  emerald: {
    blob1: 'bg-emerald-400/20',
    blob2: 'bg-cyan-300/25',
  },
} as const;

export type CardGlowVariant = keyof typeof GLOW_VARIANTS;

interface CardGlowBackgroundProps {
  variant?: CardGlowVariant;
  className?: string;
}

export function CardGlowBackground({ variant = 'purple', className }: CardGlowBackgroundProps) {
  const glow = GLOW_VARIANTS[variant];

  return (
    <div className={cn('pointer-events-none absolute inset-0 overflow-hidden', className)} aria-hidden>
      <div className={cn('absolute -right-8 -bottom-10 h-48 w-48 rounded-full blur-3xl', glow.blob1)} />
      <div className={cn('absolute right-12 bottom-4 h-32 w-32 rounded-full blur-2xl', glow.blob2)} />
    </div>
  );
}

export function pipelineCardGlowVariant(
  tone: 'purple' | 'indigo' | 'blue' | 'green',
): CardGlowVariant {
  switch (tone) {
    case 'purple':
      return 'cyan';
    case 'indigo':
      return 'cyan';
    case 'green':
      return 'emerald';
    default:
      return 'indigo';
  }
}
